import { MatCalendar } from '@angular/material/datepicker';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { OccEndpointsService, AuthConfigService, CmsBannerComponent, CmsService, OccConfig, AuthService } from '@spartacus/core';
import { UserInfoService } from '../spartacus/services/user-info.service';
import { StartOrderService } from './start-order.service';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { Router } from '@angular/router';
import { DomSanitizer, SafeHtml, SafeResourceUrl } from '@angular/platform-browser';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { AutoRolloverData } from '../custom-my-profile/custom-autorollover/custom-autorollover.component';
import { ApiFailureDialogComponent } from '../api-failure-dialog/api-failure-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { QuantitypopupComponent } from './quantitypopup/quantitypopup.component';
import { HostListener } from '@angular/core';
import { NgZone } from '@angular/core';
import { DateAdapter, NativeDateAdapter } from '@angular/material/core';
import { take } from 'rxjs/operators';

export class CustomDateAdapter extends NativeDateAdapter {
  override getDayOfWeekNames(): string[] {
    return ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
  }
}

interface DeliveryConfig {
   defaultOffsetDays: number;
   maxWindowDays: number;
   cutoffHour: number;
   disabledWeekdays: number[];
   apiDisabledDates: string[];
   infoText: string;
 }

interface CalendarConfigResponse {
   calendarDays: string;
   cutoffHour: string;
   defaultOffsetDays: string;
   disabledWeekdays: string[];
   holidayDates: string[];
   message: string;
 }
 

declare var $: any;
export interface LocationDetails {
   "locQty"?: number,
   "locID": string
}
@Component({
    selector: 'app-custom-start-order',
    templateUrl: './custom-start-order.component.html',
    styleUrls: ['./custom-start-order.component.scss'],
    standalone: false,
    
providers: [
   { provide: DateAdapter, useClass: CustomDateAdapter }
 ]
 


})
export class CustomStartOrderComponent {
   
   orderLists: any;
   membershipDecision: string = '';
   requestedMembership: any;
   fieldsetDisabled: boolean = true;
   showMembershipContent: boolean = false;
   noContent: any;
   notSureContent: any;
   yesContent: any;
   activeMembershipContent: any;
   pendingMembershipContent: any;
   duplicateproductarray:any;
   poNumber: string = '';
   needHelpContent: Observable<any> = this.cmsService.getComponentData('SeqirusStartOrderUserGuidePDFComponent');
   uid: string = '';
   quantityincreased:boolean=false;
   disableStartOrderBtn: boolean = true;
   showLocationContent: boolean = false;
   iframeUrl: any;
   displayedColumns: string[] = ['locID', 'state', 'address', 'orderExists'];
   dataSource: any;
   selection = new SelectionModel<any>(true, []);
   seasonValue: string = '';
   selectedProducts: any[] = [];
   showSelectedProducts: boolean = false;
   showProductList: boolean = false;
   units: string = '';
   shipLocationQty: LocationDetails[] = [];
   deleteduplicateinseaosn:any;
   deleteduplicatepreseaon:any;
   totalDoses: number = 0;
   totalAmount: any;
   totalquantity: number = 0;
   productForm: any = {
      productQty: []
   }
   showProductContent: boolean = false;
   showReviewContent: boolean = false;
   cartListData: any;
   termsCheckbox: boolean = false;
   mobileSeasonValue: any = 'Select New Order Type';
   showErrorMsg: boolean = false;
   showThankYouContent: boolean = false;
   duplicateSeletedArray: any[] = [];
   duplicateproductform: any[] = [];
   @ViewChild('closeButton') closeButton!: ElementRef;
   maxFileSize = 5 * 1024 * 1024;
   maxNumFilesError: boolean = false;
   isUploading: boolean = false;
   acceptedFiles = ['image/jpeg', 'image/png', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', '.eml', 'application/pdf', '.msg'];
   bulkOrderExcel: any;
   maxFileSizeError: boolean = false;
   showError1Msg: boolean = false;
   showBulkOrderSection: boolean = false;
   uploadData: string = '';
   orderSubmitContent: string = '';
   showSubmitButton: boolean = false;
   formData = new FormData();
   isLoading: boolean = false;
   progressValue: number = 0;
   showTryAgain: boolean = false;
   afluria: any;
   flaud:any;
   flucevax:any;
   fileSize: any;
   hidereorder:boolean=false;
   bannerContent: any;
   disablePlaceOrder: boolean = true;
   isCancelClicked: boolean = false;
   @ViewChild("poNumberField") poNumberField !: ElementRef;
   @ViewChild("termsCheckboxField") termsCheckboxField !: ElementRef;
   showPendingMessage: boolean=false;
   shipInfoPreseasonContent: any;
   shipInfoInseasonContent: any;
   isModelnSuccess: boolean=false;
   arrStatus?: string='';
   quantitypopup=false;
   thankYouPageData: Observable<any> = this.component.data$;
   shipFlexAccordionState: { [key: number]: boolean } = {}; //shipment flexibility accordian
   isSoldOut: boolean = false;
   showShipFlexContent: boolean = false;
   shipFlexProducts: any[] = [];
   shipFlexFilteredLocations: any[] = [];  // filtered locations for ShipFlex search
   // CHANGE: Feature flags to disable legacy prebook pages that are replaced by ShipFlex.
   readonly showLegacyLocationPage: boolean = false;
   readonly showLegacyProductPage: boolean = false;
   readonly showLegacyReviewPage: boolean = false;
   private readonly SESSION_KEY_DATES = 'shipflex_confirmed_dates';
   ONSNEnabled: boolean = false;
   private readonly SESSION_KEY_PREPAYMENT = 'prePaymentCustomer';
   showPrePaymentPopup: boolean =false;
   showPrePaymentDeclinedMessage: boolean = false;
   customerConsent: {
      device: string;
      browser: string;
      prePaymentCustomer: string;
   } | null = null;
   prePaymentTermsHeader: string = '';
   prePaymentTermsAndDescription: string = '';
   prePaymentTermsAcceptDescription: string = '';
   
 /* ================= CONFIG (REUSABLE) ================= */
 deliveryConfig: DeliveryConfig = {
   defaultOffsetDays: 7,
   maxWindowDays: 0,
   cutoffHour: 0,
   disabledWeekdays: [],
   apiDisabledDates: [],
   infoText: ''
 };

 /* ================= STATE ================= */
 isCalendarOpen = false;
 confirmedDate!: Date;
 tempSelectedDate: Date | null = null;
 monthLabel = '';

 // ✅ final delivery date per row
// confirmedDates: Record<number, Date> = {};
confirmedDates: Record<string, Date> = {};

// ✅ temp selection per row
// tempSelectedDates: Record<number, Date | null> = {};
tempSelectedDates: Record<string, Date | null> = {};
// ✅ which calendar is currently open
// openCalendarIndex: number | null = null;
openCalendarIndex: string | null = null;

 today = new Date();
 minSelectableDate!: Date;
 maxSelectableDate!: Date;
 minRescheduleDate!: Date;


 private apiDisabledSet = new Set<string>();

 @ViewChild('calendarPanel') calendarPanel!: ElementRef;
 calendar!: MatCalendar<Date>;

 @ViewChild('calendar')
 set calendarRef(cal: MatCalendar<Date>) {
   if (!cal) return;
   this.calendar = cal;

   this.ngZone.onStable.pipe(take(1)).subscribe(() => {
     this.updateMonthLabel();
     this.cdr.detectChanges();
   });

   this.calendar.stateChanges.subscribe(() => {
     this.updateMonthLabel();
     this.cdr.detectChanges();
   });
 }


   constructor(
      private dialog: MatDialog,private cmsService: CmsService, private cdr: ChangeDetectorRef, public component: CmsComponentData<any>, private occEndpointsService: OccEndpointsService, private http: HttpClient, private userInfoService: UserInfoService, private authConfigService: AuthConfigService, private startOrderService: StartOrderService, protected config: OccConfig, private router: Router, private sanitizer: DomSanitizer, private occEndPointsService: OccEndpointsService,private gtmService: GoogleTagManagerService,private renderer: Renderer2,private ngZone: NgZone,private authService: AuthService) {
   }
   


   ngOnInit(): void {

      // Clear delivery dates from session whenever user logs out
      this.authService.isUserLoggedIn().subscribe((isLoggedIn: boolean) => {
         if (!isLoggedIn) {
            sessionStorage.removeItem(this.SESSION_KEY_DATES);
         }
      });

      this.component.data$.subscribe((data: any) => {
         if (data?.prePaymentTermsHeader) {
            this.prePaymentTermsHeader = data.prePaymentTermsHeader;
         }
         if (data?.prePaymentTermsAndDescription) {
            this.prePaymentTermsAndDescription = data.prePaymentTermsAndDescription;
         }
         if (data?.prePaymentTermsAcceptDescription) {
            this.prePaymentTermsAcceptDescription = data.prePaymentTermsAcceptDescription;
         }
         this.cdr.detectChanges();
      });
    
  

    this.quantityincreased=false;
      this.getOrderDetails(); //created a function to get initial api response
      // method to get ARR status
      this.fetchAutoRolloverStatus();
      this.isModelnSuccess = localStorage.getItem('isModelnSuccess') == 'true'? true:false;
      this.cmsService.getComponentData('seqirusStartOrderMemberShipSubmitNotSure').subscribe(data => {
         this.notSureContent = data;


      })
      this.cmsService.getComponentData('seqirusStartOrderMemberShipSubmitYes').subscribe(data => {
         this.yesContent = data;


      })
      this.cmsService.getComponentData('seqirusStartOrderMemberShipSubmitNo').subscribe(data => {
         this.noContent = data;


      })
      this.cmsService.getComponentData('membership-messageComponentActive').subscribe(data => {
         this.activeMembershipContent = data;
      })
      this.cmsService.getComponentData('membership-messageComponentPending').subscribe(data => {
         this.pendingMembershipContent = data;
      })
      this.cmsService.getComponentData('shipinfocomponent-Inseason').subscribe(data => {
         this.shipInfoInseasonContent = data;
      })
      this.cmsService.getComponentData('shipinfocomponent-Preseason').subscribe(data => {
         this.shipInfoPreseasonContent = data;
      })
     /*  this.startOrderService.getAfluriaPrescribingInfoPdf().subscribe((response: any) => {
         const url = this.occEndPointsService.buildUrl(response);
         this.afluria = url.replace("occ/v2/seqirusb2b-flu360/", "");
         this.cdr.detectChanges();
      });
      this.startOrderService.getFlucevaxcPrescribingInfoPdf().subscribe((response: any) => {
         const url = this.occEndPointsService.buildUrl(response);
         this.flucevax = url.replace("occ/v2/seqirusb2b-flu360/", "");
         this.cdr.detectChanges();
      });
      this.startOrderService.getFlaudPrescribingInfoPdf().subscribe((response: any) => {
         const url = this.occEndPointsService.buildUrl(response);
         this.flaud = url.replace("occ/v2/seqirusb2b-flu360/", "");
         this.cdr.detectChanges();
      }); */


      this.cmsService.getComponentData('cartseasonbegincomponent').subscribe(data => {
         this.bannerContent = data;
      })

      
     
   }





/* ================= HELPERS ================= */
private getEasternHour(): number {
  const now = new Date();
  const easternTime = new Date(
    now.toLocaleString('en-US', { timeZone: 'America/New_York' })
  );
 
  return easternTime.getHours();
}
private isBlockedByCutoff(date: Date): boolean {
  const tomorrow = new Date(this.today);
  tomorrow.setDate(this.today.getDate() + 1);
 
  if (this.getEasternHour() >= this.deliveryConfig.cutoffHour) {
    return date.getTime() === tomorrow.getTime();
  }
  return false;
}
 
private initializeLoopDeliveryDates(): void {
   // this.items.forEach((_, index) => {
   //   this.confirmedDates[index] = new Date(this.confirmedDate);
   // });
   this.selectedProducts.forEach((product: any, i: number) => {
    const locations = product.location ?? [];
    locations.forEach((_: any, locIndex: number) => {
      const key = `${i}_${locIndex}`;
      if (!this.confirmedDates[key]) {
        this.confirmedDates[key] = new Date(this.confirmedDate);
      }
    });
  });
  // Populate flat numeric indices used by the cart summary template (confirmedDates[locIndex])
  if (this.selectedProducts.length > 0) {
   (this.selectedProducts[0].location ?? []).forEach((_: any, locIndex: number) => {
     if (this.confirmedDates[locIndex] === undefined) {
       this.confirmedDates[locIndex] = new Date(this.confirmedDate);
     }
   });
  }
 }
private calculateMinRescheduleDate(): Date {
  const base = new Date(this.today);
  base.setDate(base.getDate() + 1);
 
  if (this.getEasternHour() >= this.deliveryConfig.cutoffHour) {
    base.setDate(base.getDate() + 1);
  }
  return this.getNextValidDate(base);
}
private formatLocalDate(date: Date): string {
   const y = date.getFullYear();
   const m = (date.getMonth() + 1).toString().padStart(2, '0');
   const d = date.getDate().toString().padStart(2, '0');
   return `${y}-${m}-${d}`;
 }

 private isDayAfterApiHoliday(date: Date): boolean {
   const prevDay = new Date(date);
   prevDay.setDate(prevDay.getDate() - 1);
 
   const prevIso = this.formatLocalDate(prevDay);
   return this.apiDisabledSet.has(prevIso);
 }

 private prepareApiDisabledDates(): void {
   this.apiDisabledSet.clear();
   this.deliveryConfig.apiDisabledDates.forEach(d =>
     this.apiDisabledSet.add(d)
   );
 }
 

private normalizeToday(): void {
   this.today.setHours(0, 0, 0, 0);
 }

 private prepareDateWindow(): void {
   this.minSelectableDate = new Date(this.today);

   this.maxSelectableDate = new Date(this.today);
   this.maxSelectableDate.setDate(
     this.today.getDate() + this.deliveryConfig.maxWindowDays
   );
 }



 private updateMonthLabel(): void {
   if (!this.calendar || !this.calendar.activeDate) return;

   this.monthLabel = this.calendar.activeDate.toLocaleString('en-US', {
     month: 'long',
     year: 'numeric'
   });
 }

 /* ================= CORE BUSINESS LOGIC ================= */

 dateFilter = (date: Date | null): boolean => {
   if (!date) return false;
 
   const d = new Date(date);
   d.setHours(0, 0, 0, 0);

   
// ✅ NEW: block today
  if (d.getTime() === this.today.getTime()) {
   return false;
 }

 
   // ✅ reschedule rule
   if (this.isCalendarOpen && this.minRescheduleDate && d < this.minRescheduleDate) {
     return false;
   }
 
   // ✅ 21‑day window
   if (d < this.minSelectableDate || d > this.maxSelectableDate) {
     return false;
   }
 
   // ✅ NEW: cutoff rule
   if (this.isBlockedByCutoff(d)) {
     return false;
   }
 
   // ✅ weekend rule
   if (this.deliveryConfig.disabledWeekdays.includes(d.getDay())) {
     return false;
   }
 
   // ✅ holiday
   const localIso = this.formatLocalDate(d);
   if (this.apiDisabledSet.has(localIso)) {
     return false;
   }
 
   // ✅ day-after-holiday
   if (this.isDayAfterApiHoliday(d)) {
     return false;
   }
 
   return true;
 };
 
 

private isAfterCutoff(date: Date): boolean {
   return (
     date.getTime() === this.today.getTime() &&
     this.getEasternHour() >= this.deliveryConfig.cutoffHour
   );
 }


 private getNextValidDate(start: Date): Date {
   const d = new Date(start);
   let attempts = 0;
 
   const maxAttempts = Math.max(this.deliveryConfig.maxWindowDays + 10, 31);
 
   while (!this.dateFilter(d)) {
     d.setDate(d.getDate() + 1);
     attempts++;
 
     if (attempts > maxAttempts) {
       throw new Error('No valid delivery date available');
     }
   }
 
   return d;
 }

 private setDefaultDeliveryDate(): void {
   const base = new Date(this.today);
   base.setDate(this.today.getDate() + this.deliveryConfig.defaultOffsetDays);

   const validDate = this.getNextValidDate(base);

   this.confirmedDate = validDate;
   this.tempSelectedDate = new Date(validDate);
 }

 /* ================= UI EVENTS ================= */

 openCalendar(index: string, event: MouseEvent): void {
   event.stopPropagation();
   
 // ✅ CRITICAL FIX: recompute reschedule min date using latest config
  this.minRescheduleDate = this.calculateMinRescheduleDate();

    // initialize per-row state if missing
   if (!this.confirmedDates[index]) {
     this.confirmedDates[index] = new Date(this.confirmedDate); 
   }
   this.openCalendarIndex = index;
   this.monthLabel = this.confirmedDates[index].toLocaleString('en-US', {
      month: 'long',
      year: 'numeric'
    });
 
   // initialize per-row state if missing
   // if (!this.confirmedDates[index]) {
   //   this.confirmedDates[index] = new Date(this.confirmedDate); 
   // }
 
   this.tempSelectedDates[index] = new Date(this.confirmedDates[index]);
   this.removeCalendarNavTooltips();
}
// ADD this new private method to the class
private removeCalendarNavTooltips(): void {
  this.ngZone.onStable.pipe(take(1)).subscribe(() => {
    const navButtons = document.querySelectorAll<HTMLElement>(
      '.calendar-wrapper button.mat-calendar-previous-button, .calendar-wrapper button.mat-calendar-next-button'
    );
    navButtons.forEach(btn => {
      // Override mouseenter and focus — the exact events MatTooltip uses
      // to show tooltip and create the CDK backdrop
      btn.addEventListener('mouseenter', (e) => {
        e.stopImmediatePropagation();
      }, true); // true = capture phase, fires BEFORE Angular's listener

      btn.addEventListener('focus', (e) => {
        e.stopImmediatePropagation();
      }, true); // capture phase intercepts before MatTooltip opens
      btn.addEventListener('click', () => {
        btn.blur();
      });
    });
  });
}
 confirmDate(index: string,location?: any): void {
   const selected = this.tempSelectedDates[index];
   if (!selected) return;
   const newDate = new Date(selected); //for logic of reschedule count
   this.confirmedDates[index] = new Date(selected);
   if (location) { location.deliveryDate = new Date(newDate); } //added  newDate
   // close calendar
   this.openCalendarIndex = null;
   //Persist to session
   this.saveConfirmedDatesToSession();
 }


 private getFirstEnabledDates(count: number): Date[] {
   const enabled: Date[] = [];
   const d = new Date(this.minSelectableDate ?? this.today);
   d.setHours(0, 0, 0, 0);
   const maxAttempts = Math.max(this.deliveryConfig.maxWindowDays + 10, 31);
   for (let attempts = 0; enabled.length < count && attempts <= maxAttempts; attempts++) {
     if (this.dateFilter(d)) {
       enabled.push(new Date(d));
     }
     d.setDate(d.getDate() + 1);
   }
   return enabled;
 }

 onDateSelected(index: string, date: Date | null): void {
   if (!date) return;
   this.tempSelectedDates[index] = new Date(date);
 }

 @HostListener('document:click')
 handleOutsideClick(): void {
   this.openCalendarIndex = null;
 }

 onViewChanged(event: { activeDate: Date }): void {
   const date = event.activeDate;
 
   this.monthLabel = date.toLocaleString('en-US', {
     month: 'long',
     year: 'numeric'
   });
 }

//  This is be controlled dynamically
 //items = Array.from({ length: 2 });


   fetchAutoRolloverStatus() {
      this.userInfoService.getAutoRolloverEnrollStatus().subscribe((data:AutoRolloverData) => {
         this.arrStatus=data.enrolledStatus;
      })
   }
   getOrderDetails() {
      this.isLoading = true;
      //Initial get api call
     
      this.startOrderService.getOrderDetailsdata().subscribe((data: any) => {
         this.orderLists = data;
         this.ONSNEnabled = data?.ONSNEnabled ?? false;
       
         const calendarConfig = data?.shippingCalendar;
       
         if (calendarConfig) {
       
           this.deliveryConfig.apiDisabledDates = Array.isArray(calendarConfig.holidayDates)
             ? calendarConfig.holidayDates
             : [];
       
           this.deliveryConfig.disabledWeekdays = Array.isArray(calendarConfig.disabledWeekdays)
             ? calendarConfig.disabledWeekdays
                 .map((d: any) => Number(d))
                 .filter((d: number) => Number.isFinite(d))
             : [];
       
           this.deliveryConfig.infoText = calendarConfig.message || '';
       
           const apiMaxWindowDays = this.toValidNumber(calendarConfig.calendarDays);
           if (apiMaxWindowDays !== null) {
             this.deliveryConfig.maxWindowDays = apiMaxWindowDays;
           }
       
           const apiCutoffHour = this.toValidNumber(calendarConfig.cutoffHour);
           if (apiCutoffHour !== null) {
             this.deliveryConfig.cutoffHour = apiCutoffHour;
           }
       
           // Only this remains frontend controlled
           this.deliveryConfig.defaultOffsetDays = 7;
         }
       
         // Initialize calendar only after API config is applied
         this.normalizeToday();
         this.prepareApiDisabledDates();
         this.prepareDateWindow();
         if (this.orderLists?.orderBlock != true && this.deliveryConfig.maxWindowDays > 0) {
            this.setDefaultDeliveryDate();
            this.initializeLoopDeliveryDates();
         }
       
         if (this.orderLists?.orderBlock != true) {
           this.orderLists?.inSeasonProducts.forEach((el: any) => {
             el['productlistshow'] = true;
           });
       
           this.orderLists?.preBookProducts.forEach((el: any) => {
             el['productlistshow'] = true;
           });
       
           this.orderLists?.shippingData.forEach((item: any) => {
             item['value'] = '';
           });
         }
       
         this.selection = new SelectionModel<any>(true, []);
         this.selectedProducts = [];
         this.dataSource = new MatTableDataSource(this.orderLists?.shippingData);
         this.evaluatePrePaymentConsent();
         this.isLoading = false;
         this.cdr.detectChanges();
       
       }, (error) => {
         console.log('order error: ', error);
         this.isLoading = false;
         this.cdr.detectChanges();
       });
   }
   handleOnSeasonBtnClick(value: string) {
      if (this.showPrePaymentDeclinedMessage) {
         return;
      }
      const resolvedSeason = value === 'mobile' ? this.mobileSeasonValue : value;
      if (resolvedSeason === 'bulkOrder' && this.checkPrePaymentCustomer()) {
         return;
      }
      //triggeres when user clicks on season tiles
      this.quantityincreased=false;
      this.handleOnClearSelection(); // we should clear all the internal state flags when the user switches between the tiles
      this.seasonValue = value === 'mobile' ? this.mobileSeasonValue : value; // for mobile view the season will be shown as dropdown so mainitaining separate field
      this.mobileSeasonValue = this.mobileSeasonValue ? this.mobileSeasonValue : this.seasonValue;
      if (this.seasonValue == 'prebook') {
      this.hidereorder = false;
      this.isLoading = true;
      this.startOrderService.checkOrderExist(this.seasonValue).subscribe(data => {
         if (data.cartExist.toLocaleLowerCase() === 'yes') {
            this.initShipFlexProducts();
            this.getReviewData(); // cart exists → go directly to review
         } else {
            // cart empty → show ShipFlex product page for prebook
            this.initShipFlexProducts();
            this.showShipFlexContent = true;
            this.showBulkOrderSection = false;
            this.isLoading = false;
            this.cdr.detectChanges();
         }
      }, (error) => {
         console.log('order api error: ', error);
         this.isLoading = false;
         this.cdr.detectChanges();
      })

      }else if(this.seasonValue == 'inSeason'){
               this.hidereorder=true;
         this.isLoading = true;
         this.startOrderService.checkOrderExist(this.seasonValue).subscribe(data => { // initially check for cart exist scenario
            if (data.cartExist.toLocaleLowerCase() === 'yes') {
               this.initShipFlexProducts();
               this.getReviewData();
               this.showBulkOrderSection = false; //if cart exist show review page directly
            } else {
               //this.showLocationContent = true;
                  this.initShipFlexProducts();      //populate all locations into shipFlexProducts
                  this.showShipFlexContent = true;  //show Ship Flex page
                  this.showBulkOrderSection = false; // is cart is empty based on the tiles selection enable the page label
                  this.isLoading = false;
                  this.cdr.detectChanges();
            }
         },
            (error) => {
               console.log('order api error: ', error);
               this.isLoading = false;
               this.cdr.detectChanges();
            })

      }
      else {
         //if tiles selection was bulk order
         this.showBulkOrderSection = true;
      }
   }
   getSectionContent() {
      if (this.cartListData && this.cartListData.length > 0) { // if u have cart data show review page
         this.showReviewContent = true;
         this.cdr.detectChanges();
      } else {
         if (this.orderLists.membershipData.isMembershipDeclared) { // in case of cart empty check the user has membership or not
            if (this.seasonValue === 'prebook' || this.seasonValue === 'inSeason') {
               //if the tiles selection was inseason/preseason
               //show location page if user has membership
               if (!this.showReviewContent) {
                  this.showLocationContent = true;
                  this.showBulkOrderSection = false;
               }
            } else {
               //show tile selection was bulkorder then so buld order page
               this.showBulkOrderSection = true;
               this.showLocationContent = false;
            }
         } else {
            //show membership page if user has no membership, maintaining showMembershipContent flag for it
            this.showMembershipContent = !this.orderLists.membershipData.isMembershipDeclared;
         }
         this.cdr.detectChanges();
      }
      this.isLoading = false;
      this.cdr.detectChanges();
   }
   handleOnFormSubmit(form: any, orderLists: any) {
      // constructed membership payload
      let memberFormData = {
         currentMembership: orderLists.membershipData.currentMembership,
         membershipStatus: '',
         isContractSigned: orderLists.membershipData.isContractSigned,
         requestedMembership: form.requestedMembership || '',
         membershipDecision: form.membershipDecision
      }
      this.isLoading = true;
      this.startOrderService.postMembershipDetails(memberFormData).subscribe(data => {
         this.fieldsetDisabled = false;
         this.isLoading = false;
         if(memberFormData.membershipDecision == 'no'){
            this.showPendingMessage = true;
         }
         this.cdr.detectChanges();
      },
         (error) => {
            console.log('membership api error: ', error);
            this.isLoading = false;
            this.cdr.detectChanges();
         });
   }
   clearMembershipData() {
      this.membershipDecision = '';
   }
   handleOnStartOrderBtnClick() {
      this.showMembershipContent = false;
      if (this.seasonValue === 'inSeason' || this.seasonValue === 'prebook' ) {
         // CHANGE: ShipFlex for both inSeason and prebook when flag is on
         this.initShipFlexProducts();
         this.showShipFlexContent = true;
      } else {
         // prebook legacy flow
         this.showLocationContent = true;
      }
   }
   applyFilter(filterValue: string) {
      this.dataSource.filter = filterValue.trim().toLowerCase();
   }
   handleOnSelectAllBtnClick() {
      if (this.selection.selected.length > 0) {
         //toggle entire rows
         this.dataSource.data.forEach((row: any) => {
            if (!row.selected) {

               this.selection.toggle(row);
               row['selected'] = true;
               row['value'] = '';
               this.duplicateSeletedArray = [...this.duplicateSeletedArray, row]; // maintaining this array to track in the edit flow
            }
         });
      } else {
         //toggle the unselected rows
         this.dataSource.data.forEach((row: any) => {
            this.selection.toggle(row);
            row['value'] = "";
            row['selected'] = true;
            this.duplicateSeletedArray = [...this.duplicateSeletedArray, row];

         });
      }
   }
   handleOnRowClick(row: any) {

      this.duplicateproductarray=JSON.parse(JSON.stringify(this.selectedProducts));
      row['value'] = "";
      row['selected'] = row.selected ? !row.selected : true;
      if (!row.selected) {
         //if row is not selected previously
         this.selection.selected.forEach((el: any, index) => { // this i have written for edit flow if something is already there in selected array then splice it
            if (el.locID === row.locID) {
               this.selection.selected.splice(index, 1); // remove it from selection array if already selected location is reclicked
            }
         })

          this.selectedProducts.forEach((el: any) => { // this too i have written for edit flow if something is already there in selected array then splice it
            el.location.forEach((data: any, index: any) => {
               if (data.locID === row.locID) {
                  el.location.splice(index, 1); // remove it from selectedProducts array if already selected location is reclicked
               }
            })
         })
         this.selection = new SelectionModel<any>(true, this.selection.selected); // if its not an edit flow then just update the selection array
         this.cdr.detectChanges();
      } else {
         this.selection.toggle(row); // if row was selected then toggle it
      }
      if (this.duplicateSeletedArray.length === 0 && row.selected) { // duplicateSeletedArray is for edit flow case
         this.duplicateSeletedArray = [...this.duplicateSeletedArray, row];
      } else if (this.duplicateSeletedArray.length > 0) {
         this.duplicateSeletedArray.forEach((el: any, index) => {
            if (el.locID === row.locID) {
               this.duplicateSeletedArray.splice(index, 1);
            }
         })

      }

   }
   handleOnSelectProductClick() {

      this.showLocationContent = false;
      this.showProductContent = true;
      this.isLoading = true;
      if (this.seasonValue === 'inSeason' && this.orderLists.inSeasonProducts.length > 0) {
         this.orderLists.inSeasonProducts.forEach((item: any) => {
            item['location'] = [];
            item['location'] = this.selection.selected.map(data => ({ ...data }));
            item['showAngleDownArrow'] = item['showAngleDownArrow'] ? item['showAngleDownArrow'] : false;
         })
      }
      if (this.seasonValue === 'prebook' && this.orderLists.preBookProducts.length > 0) {
         this.orderLists.preBookProducts.forEach((item: any) => {
            item['location'] = [];
            item['location'] = this.selection.selected.map(data => ({ ...data }));
            item['showAngleDownArrow'] = item['showAngleDownArrow'] ? item['showAngleDownArrow'] : false;
         })
      }
//       if (this.selectedProducts && this.selectedProducts.length > 0) {
//          this.duplicateproductarray.find((prod:any)=>{
//             prod.location.forEach((location:any)=>{

//                this.selectedProducts.find((realprod:any)=>{
// realprod.location.forEach((realocation:any)=>{
//    if(realprod.code==prod.code){
//    if(realocation.locID==location.locID){
//       realocation.value=location.value;
//    }
// }
// })
//                })
//             })
//          })
//       }
if (this.selectedProducts && this.selectedProducts.length > 0) {
   // Build a map of previously entered values: { productCode -> { locID -> value } }
   const prevValuesMap: { [productCode: string]: { [locID: string]: any } } = {};
   this.duplicateproductarray.forEach((prod: any) => {
      prevValuesMap[prod.code] = {};
      prod.location.forEach((loc: any) => {
         prevValuesMap[prod.code][loc.locID] = loc.value;
      });
   });

   // Update each selectedProduct's location list to match the CURRENT selection,
   // restoring previously entered values where the location is still selected.
   this.selectedProducts.forEach((prod: any) => {
      // New location list = current selection only
      const newLocations = this.selection.selected.map((sel: any) => ({ ...sel }));

      // Restore previously entered quantities for locations that are still selected
      newLocations.forEach((loc: any) => {
         const prevLoc = prevValuesMap[prod.code]?.[loc.locID];
         loc.value = prevLoc !== undefined ? prevLoc : '';
      });

      prod.location = newLocations;

      // Recalculate totals based on the updated location list
      const sum = prod.location.reduce(
         (acc: number, cur: any) => acc + (Number(cur.value) || 0), 0
      );
      prod.totalquantity = sum;
      prod.totalDoses = sum * prod.doses;
      prod.totalAmount = new Intl.NumberFormat('en', {
         style: 'currency',
         currency: prod.priceData.currencyIso,
         minimumFractionDigits: 2
      }).format(sum * prod.priceData.value);
   });
}
      /*  if (this.selectedProducts && this.selectedProducts.length > 0) {
         this.selectedProducts.forEach((prod: any) => {
            this.duplicateSeletedArray && this.duplicateSeletedArray.forEach((el: any) => {
               console.log("loop");// duplicateSeletedArray mainitained for edit flow
               const obj = {
                  "address": el.address,
                  "checked": el.checked,
                  "locID": el.locID,
                  "locname": el.locname,
                  "orderExists": el.orderExists,
                  "state": el.state,
                  "selected": 'true',
                  "value": ""
               }
               prod.location = [...prod.location, obj]
            })
         })
      }  */
      this.isLoading = false;
      this.cdr.detectChanges();

   }

   restriction(event:any,i:any,index:any){
      const input = event.target as HTMLInputElement;

      const pattern = /^[0-9]*$/;
      //let inputChar = String.fromCharCode(event.charCode)
      if (!pattern.test(event.target.value)) {
        event.target.value = event.target.value.replace(/[^0-9]/g, "");
        // invalid character, prevent input

      }
   }
   handleOnAddClick(item: any, index: number) {

      this.showSelectedProducts = true;


       this.selectedProducts.forEach((products:any,i =index)=>{

        // document.getElementById('accordion1'+i)?.addEventListener('click',this.handleOnToggle(products));
          document.getElementById('part'+i)?.classList.remove('show');
          const ele=document.getElementById('accordion'+i) as HTMLElement;
         ele?.firstElementChild?.classList.add("collapsed");

          //$(ele).collapse('toggle');

         //const ele=document.getElementById('accordion'+i ) as HTMLElement;


         //this.handleOnToggle1(products);

       // accordionElement?.classList.remove('show');
         products.showAngleDownArrow=true;
         this.cdr.detectChanges();
         /* let crispClient = this.renderer.selectRootElement('#accordion'+i);
         crispClient.click(); */


        /*  if( this.seasonValue === 'inSeason'){

         this.orderLists.inSeasonProducts.forEach((listproduct:any)=>{
          if(listproduct.code==products.code){
            listproduct.showAngleDownArrow=false;
            this.cdr.detectChanges();
          }
         });
      }else{
         this.orderLists.preBookProducts.forEach((listproduct:any)=>{
            if(listproduct.code==products.code){
               listproduct.showAngleDownArrow=false;
               this.cdr.detectChanges();
             }

         });
      } */



      });

      item['totalquantity'] = this.totalquantity;
      item['totalDoses'] = this.totalDoses;
      item['totalAmount'] = this.totalAmount;
     // item['location'] = this.selection.selected.map(data => ({ ...data }));
      const defaultDate = new Date(this.confirmedDate);
      item['location'] = this.selection.selected.map(data => {
      const loc = { ...data };
      loc['deliveryDate'] = new Date(defaultDate);
      return loc;
      });
      item['showAngleDownArrow'] = false;
      if( this.seasonValue === 'inSeason'){

    this.orderLists.inSeasonProducts[index].productlistshow=false
      }else{this.orderLists.preBookProducts[index].productlistshow=false}
     // this.seasonValue === 'inSeason' ? this.orderLists.inSeasonProducts.splice(index, 1) : this.orderLists.preBookProducts.splice(index, 1);
      this.selectedProducts = [...this.selectedProducts, item];
      

   }
   handleOnToggle(item1: any,i:any) {
      item1['showAngleDownArrow'] = !item1['showAngleDownArrow'];
      if(item1.showAngleDownArrow==true){
      document.getElementById('part'+i)?.classList.remove('show');
          const ele=document.getElementById('accordion'+i) as HTMLElement;
         ele?.firstElementChild?.classList.add("collapsed");
      }else{
         document.getElementById('part'+i)?.classList.add('show');
         const ele=document.getElementById('accordion'+i) as HTMLElement;
        ele?.firstElementChild?.classList.remove("collapsed");
      }

      this.cdr.detectChanges();
   }
   handleOnDeleteBtnClick(item: any, index: number) {
      item.totalAmount = '';
      item.totalAmount = 0;
      item.totalquantity = ''
      const duplicatearraytodelete=JSON.parse(JSON.stringify(this.selectedProducts));

      item.location.forEach((data: any) => {
         data.value = ""
      })

      if( this.seasonValue === 'inSeason'){

         this.orderLists.inSeasonProducts.find((element:any) => {
            if(element.code==item.code){
            element.productlistshow=true
            }
         });
        }else{
         this.orderLists.preBookProducts.find((element:any) => {
            if(element.code==item.code){
            element.productlistshow=true
            }
         });

        }
        duplicatearraytodelete.splice(index, 1);

        duplicatearraytodelete.forEach((arrow: any) => {
         arrow.showAngleDownArrow=false
      })

         
      this.selectedProducts=  duplicatearraytodelete
    //  this.orderLists.inSeasonProducts=this.deleteduplicateinseaosn
    //  this.orderLists.preBookProducts=this.deleteduplicatepreseaon

      this.cdr.detectChanges();
      //this.orderLists.inSeasonProducts = this.seasonValue === 'inSeason' ? [...this.orderLists.inSeasonProducts, item] : [...this.orderLists.preBookProducts, item];
      if (this.selectedProducts.length == 0) {
         this.showSelectedProducts = false;
      }

   }
   handleOnAddProductBtnClick() {
      this.showProductList = !this.showProductList;
   }
  /*  handleonchangevalue(event:any,productIndex: number, locationIndex: number){

       const stringvalue1=event.target.value
      const entervalue1=Number(stringvalue1.replace(/[^0-9]/g, ''));

      this.selectedProducts[productIndex].location[locationIndex].value=entervalue1;
      this.cdr.detectChanges();
   } */
    handleOnUnitChange(prodValue: any, productIndex: number, locationIndex: number) {

       const stringvalue=prodValue.target.value.toString();
      const entervalue=Number(stringvalue.replace(/[^0-9]/g, ''));



      const value = Number(entervalue);
      this.selectedProducts[productIndex].location
      const sum = this.selectedProducts[productIndex].location.reduce((accumulator: any, current: any) => Number(accumulator) + Number(current.value), 0);
      this.selectedProducts[productIndex].totalDoses = sum ? sum * this.selectedProducts[productIndex].doses : 0;
      this.selectedProducts[productIndex].totalAmount = new Intl.NumberFormat("en",
         { style: 'currency', currency: this.selectedProducts[productIndex].priceData.currencyIso, minimumFractionDigits: 2 }
      ).format(sum * this.selectedProducts[productIndex].priceData.value);
      this.selectedProducts[productIndex].totalquantity = sum ? sum : 0;
      this.productForm.productQty.forEach((product: any) => {
         if (product.productCode === this.selectedProducts[productIndex].code) {
            product.shipLocationQty[locationIndex]['locQty'] = value;
         }
      })
      this.selectedProducts[productIndex].location[locationIndex].value=entervalue
      this.cdr.detectChanges();
   }


   handleOnPlaceOrderBtnClick() {
      //constructed place order payload
      this.isLoading = true;
      this.duplicateSeletedArray = [];
      this.productForm.productQty = [];
      this.selectedProducts.forEach(item => {
         let shippingData: LocationDetails[] = [];
         item.location && item.location.forEach((data: any) => {
            shippingData.push({ locID: data.locID, locQty: data.value })
         })
         this.productForm.productQty.push({ productCode: item.code, shipLocationQty: shippingData });
      })
    
   
      if(this.seasonValue=='prebook' && this.orderLists?.prebookAutoIncrease==true && this.orderLists?.prebookAutoIncreaseApplied==false && this.quantitypopup==false){
         this.duplicateproductform = [];
         this.duplicateproductform=JSON.parse(JSON.stringify(this.productForm.productQty))
         const prebookAutoIncreasePercent=this.orderLists?.prebookAutoIncreasePercent;
         this.duplicateproductform.forEach((dupliproduct: any) => {
            dupliproduct.shipLocationQty.forEach((locproduct:any)=>{
               locproduct['increaseqty']=Number(locproduct.locQty) + Number(Math.round(locproduct.locQty*prebookAutoIncreasePercent/100))
            });
         });
         this.quantitypopup=true
         this.isLoading=false
         this.startOrderService.setquantitypopup().subscribe((data: any) => {
         });
         this.dialog.open(QuantitypopupComponent, {
            disableClose: true,
            data:[this.duplicateproductform, this.orderLists.preBookProducts,this.orderLists.shippingData]
          });
         
       
      }else{
      
      this.startOrderService.addToCart(this.productForm, this.seasonValue).subscribe((data: any) => {
         this.getReviewData(); // you have to hit 2 apis
        //this.userInfoService.setcarttigger("changed");
      },
         (error) => {
            console.log('add to cart api error: ', error);
            this.isLoading = false;
            this.cdr.detectChanges();
         })
      }
   }
   getReviewData() {
      this.startOrderService.getReviewPageData(this.seasonValue).subscribe((reviewData: any) => {
         this.cartListData = reviewData;
         this.cdr.detectChanges();
         this.startOrderService.getIframeUrl(this.seasonValue,this.orderLists).subscribe((iframe: any) => { // to show terms and codition section, I triggerred api call and got the url
            let url = this.occEndPointsService.buildUrl(`${iframe}`); //&embedded=true
            url = url.replace("occ/v2/seqirusb2b-flu360/", "");
            this.iframeUrl = url;
            this.restoreQuantitiesToShipFlexProducts(); //Restore cart quantities into shipFlexProducts so buildLocationDatesPayload() works correctly
            if (!this.showReviewContent && (this.showProductContent || this.showShipFlexContent)) { // this triggers for create flow
               this.showReviewContent = true;
               this.showProductContent = false;
               this.showShipFlexContent = false;
            }
            else {
               //this part you can leave, no where Im using selectedProdListArray, now i dont have time to comment and check the flow so Im leaving as it is
               this.showReviewContent = true;
               const selectedProdListArray = this.cartListData.products.filter((item: any) => {
                  const prodNameArray = item.productCode.split(',');
                  if (this.seasonValue === 'inSeason') {
                     return this.orderLists.inSeasonProducts.find((el: any) => {
                        if (prodNameArray.includes(el.code)) { return el };
                     })
                  } else {
                     return this.orderLists.preBookProducts.find((el: any) => {
                        if (prodNameArray.includes(el.code)) { return el };
                     })
                  }

               })
            }
            this.isLoading = false;
            this.cdr.detectChanges();
         },
            (error) => {
               console.log('iframe api error: ', error);
               this.isLoading = false;
               this.cdr.detectChanges();
            })
      },
         (error) => {
            console.log('review api error: ', error);
            this.isLoading = false;
            this.cdr.detectChanges();
         });
   }
   handleOnBackToLocationBtnClick() {
      //update selection array when u click on back button it handles both edit and create case
      this.duplicateproductarray = JSON.parse(JSON.stringify(this.selectedProducts));
      this.duplicateSeletedArray = [];
      this.selection.selected.forEach((row: any) => {
         this.dataSource.data.find((el: any) => {
            if (row.locID === el.locID) {
               el['selected'] = true;
            }
         })
      })

      this.showLocationContent = true;
      this.showProductContent = false;
   }
   getImage(image: any): string {
      return this.config.backend?.occ?.baseUrl + image.url;
   }
   handleOnBackToProductBtnClick() {
      //update selectedProducts array on click of back button. it handles both edit and create flow
      this.showReviewContent = false;
      this.showProductContent = true;
      this.showErrorMsg = false;
      const duplicateselectedarrayinseaosn=JSON.parse(JSON.stringify(this.orderLists.inSeasonProducts));
      const duplicatepreseaon= JSON.parse(JSON.stringify(this.orderLists.preBookProducts));

      if (this.selectedProducts.length<1) {
      if (this.seasonValue === 'inSeason') {

         this.orderLists.inSeasonProducts.forEach((item: any, index: number) => {

            this.cartListData.data.find((el: any) => {

               if (el.productCode === item.code) {

                  let locationArray: any[] = [];
                  item['totalquantity'] = el.totalquantity;
                  item['totalDoses'] = (Number(el.totalquantity) * item.doses).toString();
                  item['totalAmount'] = el.totalcost.includes('$') ? el.totalcost : new Intl.NumberFormat("en",
                     { style: 'currency', currency: "USD", minimumFractionDigits: 2 }
                  ).format(el.totalcost);
                  item['showAngleDownArrow'] = false;

                  el.locations.forEach((loc: any) => {
                     this.orderLists.shippingData.find((location: any) => {
                        if (location.locID === loc.locID) {
                           const obj = {
                              "address": location.address,
                              "checked": location.checked,
                              "locID": location.locID,
                              "locname": location.locname,
                              "orderExists": location.orderExists,
                              "state": location.state,
                              "value": loc.locqtn,

                           }
                           locationArray = [...locationArray, obj];

                        }
                     })
                  })
                  if (item.location) {
                     item.location.length = 0;
                     item.location = locationArray;
                  } else {
                     item['location'] = locationArray;
                  }
                  this.selectedProducts = [...this.selectedProducts, item];
                  //console.log(this.selectedProducts)

                  // this.selectedProducts.forEach((el: any) => {
                  //    this.selection.select(el)
                  // })

                  item.productlistshow=false

                 // duplicateselectedarrayinseaosn.splice(index, 1);
               }
            })
         })
         //this.orderLists.inSeasonProducts=duplicateselectedarrayinseaosn;



      } else {
         this.orderLists.preBookProducts.forEach((item: any, index: number) => {
            this.cartListData.data.find((el: any) => {
               if (el.productCode === item.code) {
                  let locationArray: any[] = [];
                  item['totalquantity'] = el.totalquantity;
                  item['totalDoses'] = (Number(el.totalquantity) * item.doses).toString();
                  item['totalAmount'] = el.totalcost;
                  item['showAngleDownArrow'] = false;

                  el.locations.forEach((loc: any) => {
                     this.orderLists.shippingData.find((location: any) => {
                        if (location.locID === loc.locID) {
                           const obj = {
                              "address": location.address,
                              "checked": location.checked,
                              "locID": location.locID,
                              "locname": location.locname,
                              "orderExists": location.orderExists,
                              "preBookOrderExists":location.preBookOrderExists,
                              "state": location.state,
                              "value": loc.locqtn,

                           }
                           locationArray = [...locationArray, obj];

                        }
                     })
                  })
                  if (item.location) {
                     item.location.length = 0;
                     item.location = locationArray;
                  } else {
                     item['location'] = locationArray;
                  }
                  this.selectedProducts = [...this.selectedProducts, item];

                  // this.selectedProducts.forEach((el: any) => {
                  //    this.selection.select(el)
                  // })
                  item.productlistshow=false
                  //duplicatepreseaon.splice(index, 1);
               }
            })
         })
        // this.orderLists.preBookProducts=duplicatepreseaon;
      }
   }
      if (this.selectedProducts && this.selectedProducts.length > 0) {
         this.selection = new SelectionModel<any>(true, []);
         this.selectedProducts[0].location.forEach((el: any) => {
            this.selection.toggle({
               "address": el.address,
               "checked": el.checked,
               "locID": el.locID,
               "locname": el.locname,
               "orderExists": el.orderExists,
               "preBookOrderExists":el.preBookOrderExists,
               "state": el.state,
               "selected": 'true'
            });
         })

         this.showSelectedProducts = true;

      }
this.cdr.detectChanges
   }
   handleOnDeleteModelYesBtnClick() {
      //this.isLoading = true;
      this.startOrderService.deleteCartData(this.seasonValue).subscribe(data => {
         if(this.seasonValue === 'inSeason'){
         sessionStorage.removeItem(this.SESSION_KEY_DATES);
         }
         this.showReviewContent = false;
         this.showShipFlexContent = false; // reset Ship Flex visibility on delete
         this.shipFlexProducts = [];       // clear Ship Flex products on delete
         this.getOrderDetails();
         this.closeButton.nativeElement.click();
         //this.isLoading = false;
         this.seasonValue = '';
         this.cartListData = [];
        // this.selection = new SelectionModel<any>(true, []); // the selection array has the selected location details
         //this.selectedProducts=[]; // In product page,if the user clicks on add product then the selected product should be visible above it so to track that i created this array
        
         //this.duplicateSeletedArray = [];
         //this.selection.clear();
        
         //this.userInfoService.setcarttigger("changed");
         this.cdr.detectChanges();
      },
         (error) => {
            console.log('delete api error: ', error);
            this.isLoading = false;
            this.cdr.detectChanges();
         });
   }
   handleOnPlaceOrder() {
    //constructed review page payload
    this.isLoading = true;
    const locationDates =  (this.seasonValue === 'inSeason'&& this.ONSNEnabled)? this.buildLocationDatesPayload():[];
   const customerConsent = this.customerConsent ?? undefined;
    this.startOrderService.placeOrderAPI( this.poNumber, this.seasonValue,customerConsent, locationDates.length > 0 ? locationDates : undefined ).subscribe(data => {
      if (data) {
         if(this.seasonValue === 'inSeason'){
            sessionStorage.removeItem(this.SESSION_KEY_DATES);
         }
        this.showThankYouContent = true;
        this.showReviewContent = false;
        data = JSON.stringify(data);
        this.cdr.detectChanges();
        const gtmTag = {
          event: 'transaction',
          ecommerce: data
        };
        this.gtmService.pushTag(gtmTag);
      }
      this.isLoading = false;
      this.cdr.detectChanges();
    },
      (error) => {
        console.log('place order api error: ', error);
        this.isLoading = false;
        this.cdr.detectChanges();
      });
  }
  // Compares each location's deliveryDate with the default confirmedDate.
  private buildLocationDatesPayload(): Array<{ locationID: string; expectedDate: string; isonsnorder:string }> {
    const locationDates: Array<{ locationID: string; expectedDate: string; isonsnorder: string }> = [];
    if (this.seasonValue !== 'inSeason') {
      return locationDates;
    }
    if (!this.shipFlexProducts || this.shipFlexProducts.length === 0) {
      return locationDates;
    }
    const locations = this.shipFlexProducts[0]?.location ?? [];
    const defaultDate = this.confirmedDate instanceof Date ? this.confirmedDate : new Date(this.confirmedDate);
    const defaultIso = this.formatLocalDate(defaultDate);
    const firstTwoIso=this.getFirstEnabledDates(2).map(date=>
      this.formatLocalDate(date)
    );
    locations.forEach((loc: any) => {
      if (!this.hasQtyForLocation(loc.locID)) return;
      const locationDeliveryDate: Date = loc.deliveryDate ? (loc.deliveryDate instanceof Date ? loc.deliveryDate : new Date(loc.deliveryDate)) : defaultDate;
      const selectedIso = this.formatLocalDate(locationDeliveryDate);
      const isRescheduled = selectedIso !== defaultIso;
      const isONSNOrder=firstTwoIso.includes(selectedIso) ? 'YES' : 'NO';
      locationDates.push({  locationID: loc.locID,  expectedDate: selectedIso, isonsnorder:isONSNOrder });
    });
    return locationDates;
  }
  private hasQtyForLocation(locID: string): boolean {
    return this.shipFlexProducts.some((p: any) =>
      (p.location || []).some((l: any) => l.locID === locID && Number(l.value) > 0)
    );
  }

   handleOnAutoGeneratePoNo() {
      this.startOrderService.getPORefNumber().subscribe(data => {
         this.poNumber = data;
         this.cdr.detectChanges();
      });
   }
   handleOnViewOrders() {
      this.router.navigate(['/orders/my-orders']);
   }
   cleanURL(): SafeResourceUrl {
      return this.sanitizer.bypassSecurityTrustResourceUrl(this.iframeUrl + `#toolbar=0&navpanes=0&view=FitH`);
   }
   filesValidator(control: any) {
      const files = control.value;
      let totalSize = 0;
      for (const file of files) {
         totalSize += file.size;
      }
      if (totalSize > this.maxFileSize) {
         return { maxFileSize: true };
      }
      return null;
   }
   onFileChange(event: any) {
      this.isUploading = true;
      const fileList: FileList = event.target.files;
      if (fileList.length > 0) {
         const file: File = fileList[0];
         this.bulkOrderExcel = file;
         if (this.bulkOrderExcel.size < 1000000) {
            this.fileSize = Math.floor(this.bulkOrderExcel.size / 1000) + 'KB';
         } else {
            this.fileSize = Math.floor(this.bulkOrderExcel.size / 1000000) + 'MB';
         }
      }
      if (this.bulkOrderExcel.size > this.maxFileSize) {
         this.showError1Msg = true;
      } else {
         this.formData = new FormData();
         this.formData.append('bulkOrderExcel', this.bulkOrderExcel, this.bulkOrderExcel.name);
         this.startOrderService.uploadFile(this.formData).subscribe((data: any) => {
            if (data.type == 0) {
               this.progressValue = 0;
               this.cdr.detectChanges();
               this.progressValue = this.progressValue + 10;
               this.cdr.detectChanges();
            }
            if (data.type == 2) {
               this.progressValue = 40;
               this.cdr.detectChanges();
            }
            if (data.type == 3) {
               this.progressValue = 70;
               this.cdr.detectChanges();
            }
            if (data['body']) {
               this.progressValue = 100;
               this.cdr.detectChanges();
               setTimeout(() => {
                  if(data.body) {
                  this.uploadData = data.body;
                  this.cdr.detectChanges();
                  }
               }, 2000);

            }
         },
         (error) => {
            this.uploadData = 'failure';
            this.cdr.detectChanges();
            console.log('error: ', error);
         })
      }

   }
   addFiles(file: any) {
      if (file.size > this.maxFileSize) {
         this.maxNumFilesError = true;
      }
      this.isUploading = false;
      this.cdr.detectChanges();
   }
   onDragOver(event: DragEvent) {
      event.preventDefault();
   }
   onDragLeave(event: DragEvent) {
      event.preventDefault();
   }
   onDrop(event: DragEvent) {
      this.isUploading = true;
      event.preventDefault();
      if (event.dataTransfer?.files) {
          const files = Array.from(event.dataTransfer.files) as File[];
          if (files.length > 0) {
              const file: File = files[0];
              const validTypes = [
                  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                  'application/vnd.ms-excel'
              ];
              if (!validTypes.includes(file.type)) {
                  this.showError1Msg = true;
                  this.isUploading = false;
                  return;
              }
              this.bulkOrderExcel = file;
              if (this.bulkOrderExcel.size > this.maxFileSize) {
                  this.showError1Msg = true;
              } else {
               this.formData = new FormData();
                  this.formData.append('bulkOrderExcel', this.bulkOrderExcel, this.bulkOrderExcel.name);
                  this.startOrderService.uploadFile(this.formData).subscribe((data: any) => {
                      if (data.type == 0) {
                          this.progressValue = 0;
                          this.cdr.detectChanges();
                          this.progressValue = this.progressValue + 10;
                          this.cdr.detectChanges();
                      }
                      if (data.type == 2) {
                          this.progressValue = 40;
                          this.cdr.detectChanges();
                      }
                      if (data.type == 3) {
                          this.progressValue = 70;
                          this.cdr.detectChanges();
                      }
                      if (data['body']) {
                          this.progressValue = 100;
                          this.cdr.detectChanges();
                          /* setTimeout(() => {
                              this.uploadData = 'success';
                              this.cdr.detectChanges();
                          }, 2000); */
                          setTimeout(() => {
                           if(data.body) {
                           this.uploadData = data.body;
                           this.cdr.detectChanges();
                           }
                        }, 2000);
                      }
                  },
                  (error) => {
                     this.uploadData = 'failure';
                     this.cdr.detectChanges();
                     console.log('error: ', error);
                  }
               );
                  this.cdr.detectChanges();
              }
          }
      }
  }
   removeFile() {
      this.bulkOrderExcel = '';
      this.maxNumFilesError = false;
      this.maxFileSizeError = false;
      this.isUploading = false;
      this.uploadData = '';
      this.showError1Msg=false;
      this.showTryAgain = false;
      this.isCancelClicked = true;
   }
   handleOnBulkOrderSeasonBtnClick(season: string) {
      this.isLoading = true;
      this.startOrderService.getBulkOrderSeasonDocument(season)
         .subscribe(
            (data: any) => {
               this.isLoading = false;
               this.cdr.detectChanges();
               const contentDisposition = data.headers.get('Content-disposition').split('filename=')[1];
               const file = new Blob([data.body]);
               const fileURL = URL.createObjectURL(file);
               const a = document.createElement('a');
               a.href = fileURL;
               a.download = contentDisposition.replace(/["]+/g, '').trimStart();
               document.body.appendChild(a);
               a.click();
            },
            (error) => {
               console.log('download pdf error: ', error);
               this.isLoading = false;
               this.cdr.detectChanges();
            }
         );


   }
   handleOnTryAgainBtnClick() {
      this.isUploading = false;
      this.showError1Msg = false;
      this.orderSubmitContent = "";
      this.uploadData = "";
      this.progressValue = 0;
      this.showTryAgain = false;
   }
   handleOnUploadSubmit() {
      this.isLoading = true;
      this.startOrderService.submitFile(this.formData).subscribe((data: any) => {
         this.orderSubmitContent = data;
         this.isLoading = false;
         this.cdr.detectChanges();
      },
         (error) => {
            console.log('upload file error: ', error);
            this.orderSubmitContent = 'success';
            this.isLoading = false;
            this.cdr.detectChanges();
         })
   }
   handleOnClearSelection() {
      this.selection.clear();
      this.duplicateSeletedArray = [];
      this.selectedProducts = [];
      this.showReviewContent=false;
      this.showLocationContent = false;
      this.showProductContent = false;
      this.showReviewContent = false;
      this.showMembershipContent = false;
      this.showThankYouContent = false;
      this.showShipFlexContent = false; // reset Ship Flex page visibility
      this.shipFlexProducts = [];       // clear Ship Flex products array
     /*  this.showBulkOrderSection = false;



      this.showErrorMsg = false; */
      this.orderLists.shippingData.forEach((el: any) => {
         el.selected = false;
      })
      this.membershipDecision = '';
      this.cdr.detectChanges();
   }
   handleonclearbtnclick(){
      this.selection.clear();
      this.duplicateSeletedArray = [];
      this.selectedProducts = [];
      this.showSelectedProducts = false; 
      this.showProductList = false;
     /*  this.showReviewContent=false;
      this.showLocationContent = false;
      this.showProductContent = false;
      this.showReviewContent = false;
      this.showMembershipContent = false;
      this.showThankYouContent = false; */
     /*  this.showBulkOrderSection = false;
     

      this.showErrorMsg = false; */

      this.orderLists.inSeasonProducts.forEach((el: any) => {
         el.productlistshow = true;
         el.showAngleDownArrow = false;
      });
      this.orderLists.preBookProducts.forEach((el: any) => {
         el.productlistshow = true;
         el.showAngleDownArrow = false;
      });
      this.orderLists.shippingData.forEach((el: any) => {
         el.selected = false;
      })
      this.membershipDecision = '';
      this.cdr.detectChanges();
   }
   handleOnToggle1(item: any,i:any) {

      item['showAngleDownArrow'] = item['showAngleDownArrow'] ? !item['showAngleDownArrow'] : false;
      if(item.showAngleDownArrow==true){
         document.getElementById('part'+i)?.classList.remove('show');
             const ele=document.getElementById('accordion'+i) as HTMLElement;
            ele?.firstElementChild?.classList.add("collapsed");
         }else{
            document.getElementById('part'+i)?.classList.add('show');
            const ele=document.getElementById('accordion'+i) as HTMLElement;
           ele?.firstElementChild?.classList.remove("collapsed");
         }

      this.cdr.detectChanges();
   }
   handleOnReorderClick() {
      if (this.showPrePaymentDeclinedMessage) {
         return;
      }
      this.isLoading = true;
      this.startOrderService.preBookRollOver().subscribe((data: any) => {
         if (data == 'success') {
            this.showLocationContent=false;
            this.showProductContent=false;
            this.showBulkOrderSection=false;
            this.orderLists.validForRebook = false;
            this.seasonValue = 'prebook';
            this.cdr.detectChanges();
            this.getReviewData();
         }
      }, (error) => {
         console.log('upload file error: ', error);
         this.isLoading = false;
         this.cdr.detectChanges();
      })
   }
   handleMyOrdersLink(address: string) {
      this.router.navigate(
         ['/orders/my-orders'],
         { queryParams: { season: this.seasonValue == 'inSeason' ? this.orderLists.inSeasonYear  : this.orderLists.preSeasonYear, address: address } }
      );
   }
   handleOnLinkClick(event: any) {
      event.preventDefault();
      window.open(this.iframeUrl, '_blank');
   }
   scrollToTop(): void {
      window.scrollTo({ top: 0, behavior: 'smooth' });
   }
   focusOnInputField() {
      if (!this.poNumber) {
         this.poNumberField.nativeElement.focus();
         this.showErrorMsg = true;
      }
      if (!this.termsCheckbox) {
         this.termsCheckboxField.nativeElement.focus();
         this.showErrorMsg = true;
      }
      if (this.poNumber && this.termsCheckbox) {
         this.showErrorMsg = false;
         this.handleOnPlaceOrder();
         this.scrollToTop();
      }
   }
   handleOnPrePaymentYes() {
      this.showPrePaymentPopup = false;

      this.showPrePaymentDeclinedMessage = false;

      this.customerConsent = {
         device: this.getDeviceType(),
         browser: this.getBrowserName(),
         prePaymentCustomer:
            sessionStorage.getItem(this.SESSION_KEY_PREPAYMENT) || ''
      };

      this.cdr.detectChanges();
   }
   private evaluatePrePaymentConsent(): void {
   if (this.orderLists?.orderBlock === true) {
      return;
   }
   if (!this.checkPrePaymentCustomer()) {
      return;
   }
   this.showPrePaymentPopup = true;
   this.cdr.detectChanges();
}
handleOnPrePaymentNo() {

   this.showPrePaymentPopup = false;
   this.showPrePaymentDeclinedMessage = true;

   this.customerConsent = null;

   this.cdr.detectChanges();
}
    private getDeviceType(): string {
     const ua = navigator.userAgent || '';
     const isIpad = /Macintosh/i.test(ua) && navigator.maxTouchPoints > 1;
     if (isIpad || /iPad|Tablet|Android(?!.*Mobile)/i.test(ua)) return 'Tablet';
     if (/Mobi|Android|iPhone|iPod|Windows Phone/i.test(ua)) return 'Mobile';
     return 'Desktop';
   }
   private getBrowserName():string {
      const ua=navigator.userAgent || '';
      if(/Edg\//i.test(ua)) return 'Edge';
      if(/OPR\//i.test(ua) || /Opera/i.test(ua)) return 'Opera';
      if(/Chrome\//i.test(ua) && !/Edg\//i.test(ua)) return 'Chrome';
      if(/Firefox\//i.test(ua)) return 'Firefox';
      if(/Safari\//i.test(ua) && !/Chrome\//i.test(ua)) return 'Safari';
      if(/Trident|MSIE/i.test(ua)) return 'Internet Explorer';
      return 'Other'
   }
   disablePlaceOrderBtn() {
      if (this.selectedProducts.length > 0) {
         const productArray = this.selectedProducts.find((el: any) => { return el.totalquantity == 0 });
         return productArray != undefined;
      } else {
         return true
      }
   }
   handleonUndo(){
      this.quantityincreased=false;
      this.duplicateproductform.forEach((dupliproduct: any) => {
         let totalquantity=0;
       this.orderLists?.preBookProducts.forEach((productdata:any)=>{
     
      
         
         if(productdata?.code==dupliproduct.productCode){
            dupliproduct.shipLocationQty.forEach((shippinglocation:any)=>{
               productdata?.location.forEach((location:any)=>{
                  if(location.locID==shippinglocation.locID){
                     location.value=shippinglocation.locQty;
                  }
               })
               totalquantity= totalquantity + shippinglocation.locQty
            })
         
         productdata.totalquantity=totalquantity
         productdata.totalDoses=totalquantity*productdata?.doses;
         productdata.totalAmount=totalquantity*productdata.priceData.value;
         productdata.totalAmount=new Intl.NumberFormat("en",
           { style: 'currency', currency: "USD", minimumFractionDigits: 2 }
         ).format(productdata.totalAmount);
         }
      });
     
   });
  this.cdr.detectChanges();
   
   }

/*======NEW METHODS added for Shipping Flexibility=====*/
initShipFlexProducts(): void {
      const products = this.seasonValue === 'inSeason'
         ? this.orderLists.inSeasonProducts
         : this.orderLists.preBookProducts;
 
      this.shipFlexProducts = products.map((item: any) => {
         const product = { ...item };
         // Attach all shippingData locations with empty value and default delivery date
         product['location'] = this.orderLists.shippingData.map((loc: any, idx: number) => ({
            ...loc,
            value: '',
            deliveryDate: new Date(this.confirmedDate),
            isExpanded: idx < 2  
         }));
         product['totalquantity'] = 0;
         product['totalDoses'] = 0;
         product['totalAmount'] = '';
         product['showAngleDownArrow'] = false;
         return product;
      });
 
      // Sync selectedProducts so review/order payload logic still works
      this.selectedProducts = this.shipFlexProducts;
      // Initialize filtered locations from all locations of first product
      this.shipFlexFilteredLocations = this.shipFlexProducts[0]?.location ?? [];
      // Each location's deliveryDate is freshly set to confirmedDate above,
      // so we sync the calendar state maps to match.
      this.confirmedDates = {};
      this.tempSelectedDates = {};
      (this.shipFlexProducts[0]?.location ?? []).forEach((_: any, locIdx: number) => {
         const key = `0_${locIdx}`;
         this.confirmedDates[key] = new Date(this.confirmedDate);
         this.tempSelectedDates[key] = null; // null = no selection yet, calendar opens clean
      });
      this.initializeLoopDeliveryDates();
      //Restore any previously saved dates (survives page navigation)
      this.restoreConfirmedDatesFromSession();

      // Sync location.deliveryDate objects to match restored confirmedDates
      (this.shipFlexProducts[0]?.location ?? []).forEach((loc: any, locIdx: number) => {
         const key = `0_${locIdx}`;
         if (this.confirmedDates[key]) {
            loc.deliveryDate = new Date(this.confirmedDates[key]);
         }
      });
      this.cdr.detectChanges();
   }
 
   /**Handles qty input changes on the Ship Flex product page.
    * Recalculates totalquantity, totalDoses, totalAmount for the changed product.
    * Replaces handleOnUnitChange() in the Ship Flex context.
    */
   handleOnShipFlexUnitChange(event: any, pIdx: number, locIndex: number): void {
   const enterValue = Number(event.target.value.toString().replace(/[^0-9]/g, ''));
   this.shipFlexProducts[pIdx].location[locIndex].value = enterValue;

   const product = this.shipFlexProducts[pIdx];

   // Grand totals across ALL locations (used for payload + disable button check)
   const totalSum = product.location.reduce(
      (acc: number, loc: any) => acc + Number(loc.value || 0), 0
   );
   product.totalquantity = totalSum;
   product.totalDoses = totalSum * product.doses;
   product.totalAmount = totalSum > 0
      ? new Intl.NumberFormat('en', {
         style: 'currency',
         currency: product.priceData?.currencyIso || 'USD',
         minimumFractionDigits: 2
      }).format(totalSum * (product.priceData?.value || 0))
      : '';

   // Per-location cost/doses — stored on the location object itself for display
   const locQty = Number(enterValue || 0);
   product.location[locIndex].locDoses = locQty * product.doses;
   product.location[locIndex].locAmount = locQty > 0
      ? new Intl.NumberFormat('en', {
         style: 'currency',
         currency: product.priceData?.currencyIso || 'USD',
         minimumFractionDigits: 2
      }).format(locQty * (product.priceData?.value || 0))
      : '';

   this.cdr.detectChanges();
}
 
   /**
    * NEW METHOD. Returns the sum of all product quantities for a given location index.
    * Used in the Ship Flex template to show total qty in each location row header.
    */
   getLocationTotalQty(locIndex: number): number {
      return this.shipFlexProducts.reduce(
         (total: number, product: any) => total + Number(product.location?.[locIndex]?.value || 0), 0
      );
   }
   getLocationOriginalIndex(location: any): number {
   if (!this.shipFlexProducts || this.shipFlexProducts.length === 0) return 0;
   return (this.shipFlexProducts[0]?.location ?? []).findIndex(
      (loc: any) => loc.locID === location.locID
   );
}
 
   /**
    * NEW METHOD. Returns true (disables button) if no product has any quantity > 0.
    * Used by the Ship Flex "Review & Place Order" button [disabled] binding.
    */
   disableShipFlexPlaceOrderBtn(): boolean {
      if (!this.shipFlexProducts || this.shipFlexProducts.length === 0) return true;
      return !this.shipFlexProducts.some((p: any) => Number(p.totalquantity) > 0);
   }
 
   /**
    * NEW METHOD. Builds the order payload from shipFlexProducts and submits to cart API,
    * then calls getReviewData() to navigate to the review page.
    */
   handleOnShipFlexPlaceOrderBtnClick(): void {
      this.isLoading = true;
      this.duplicateSeletedArray = [];
      this.productForm.productQty = [];
 
      // Build payload from shipFlexProducts (all products × all locations)
      this.shipFlexProducts.forEach((item: any) => {
         const shippingData: LocationDetails[] = [];
         item.location?.forEach((loc: any) => {
            shippingData.push({ locID: loc.locID, locQty: loc.value || 0 });
         });
         this.productForm.productQty.push({ productCode: item.code, shipLocationQty: shippingData });
      });
 
      // Ensure selectedProducts is in sync for downstream review page logic
      this.selectedProducts = this.shipFlexProducts;
 
      this.startOrderService.addToCart(this.productForm, this.seasonValue).subscribe((data: any) => {
         this.showShipFlexContent = false; // hide Ship Flex before going to review
         this.getReviewData();
      }, (error) => {
         console.log('add to cart api error: ', error);
         this.isLoading = false;
         this.cdr.detectChanges();
      });
   }
 
   /**.
    * Hides the review page and re-shows the Ship Flex product page.
    */
  handleOnBackToShipFlexBtnClick(): void {
   this.showReviewContent = false;
   this.showErrorMsg = false;

   // Re-initialize shipFlexProducts from cartListData if empty on back navigation.
   // This restores qty values from the review page so inputs remain bound and editable.
   if (!this.shipFlexProducts || this.shipFlexProducts.length === 0) {
      this.initShipFlexProducts();

      // Restore previously entered quantities from cartListData if available
      if (this.cartListData?.data) {
         this.cartListData.data.forEach((reviewProduct: any) => {
            const matchingProduct = this.shipFlexProducts.find(
               (p: any) => p.code === reviewProduct.productCode
            );
            if (matchingProduct) {
               reviewProduct.locations?.forEach((reviewLoc: any) => {
                  const locIdx = matchingProduct.location.findIndex(
                     (l: any) => l.locID === reviewLoc.locID
                  );
                  if (locIdx > -1 && reviewLoc.locqtn) {
                     matchingProduct.location[locIdx].value = Number(reviewLoc.locqtn);
                  }
               });
               // Recalculate totals after restoring
               matchingProduct.location.forEach((loc: any) => {
                  const locQty = Number(loc.value || 0);
                  loc.locDoses = locQty * matchingProduct.doses;
                  loc.locAmount = locQty > 0
                     ? new Intl.NumberFormat('en', {
                        style: 'currency',
                        currency: matchingProduct.priceData?.currencyIso || 'USD',
                        minimumFractionDigits: 2
                     }).format(locQty * (matchingProduct.priceData?.value || 0))
                     : '';
               });

               // Recalculate grand totals after restoring
               const sum = matchingProduct.location.reduce(
                  (acc: number, loc: any) => acc + Number(loc.value || 0), 0
               );
               matchingProduct.totalquantity = sum;
               matchingProduct.totalDoses = sum * matchingProduct.doses;
               matchingProduct.totalAmount = sum > 0
                  ? new Intl.NumberFormat('en', {
                     style: 'currency',
                     currency: matchingProduct.priceData?.currencyIso || 'USD',
                     minimumFractionDigits: 2
                  }).format(sum * (matchingProduct.priceData?.value || 0))
                  : '';
               }
            });
            this.selectedProducts = this.shipFlexProducts;
         }
      }

      this.showShipFlexContent = true;
      this.cdr.detectChanges();
   }

   private toValidNumber(value: any): number | null {
      if (value === null || value === undefined || value === '') {
        return null;
      }
    
      const num = Number(value);
      return Number.isFinite(num) ? num : null;
    }

   applyShipFlexFilter(filterValue: string): void {
   const search = filterValue.trim().toLowerCase();
   if (!search) {
      // Reset to all locations when search is empty
      this.shipFlexFilteredLocations = this.shipFlexProducts[0]?.location ?? [];
   } else {
      this.shipFlexFilteredLocations = (this.shipFlexProducts[0]?.location ?? []).filter((loc: any) =>
         (loc.locname || '').toLowerCase().includes(search) ||
         (loc.address || '').toLowerCase().includes(search) ||
         (loc.state || '').toLowerCase().includes(search)
      );
   }
   this.cdr.detectChanges();
}

resetShipFlexFilter(searchInput: HTMLInputElement): void {
   searchInput.value = '';
   this.shipFlexFilteredLocations = this.shipFlexProducts[0]?.location ?? [];
   this.cdr.detectChanges();
}
getReviewLocationIndex(locID: string): number {
   if (!this.selectedProducts || this.selectedProducts.length === 0) return 0;
   return (this.selectedProducts[0]?.location ?? []).findIndex(
      (loc: any) => loc.locID === locID
   );
}
/**
 *shipFlexFilteredLocations holds direct object references from
 * shipFlexProducts[0].location — so 'location' and 'originalLoc' are
 * the SAME object in memory. Toggling both was double-toggling,
 * cancelling out the change. Now we toggle only once via the original
 * reference to ensure state persists correctly after search/filter resets.
 */
toggleShipFlexAccordion(location: any): void {
   // Find the canonical object in the source array
   const originalLoc = (this.shipFlexProducts[0]?.location ?? []).find(
      (l: any) => l.locID === location.locID
   );
   if (originalLoc) {
      // Toggle only once on the original object.
      originalLoc.isExpanded = !originalLoc.isExpanded;
   }
   this.cdr.detectChanges();
}
/**
 * Returns the sum of all product quantities across all locations
 * for the mobile review page grand total row.
 */
getTotalMobileQty(): number {
   if (!this.cartListData?.productstotalQty) return 0;
   return this.cartListData.productstotalQty.reduce(
      (sum: number, item: any) => {
         const raw = String(item.qty || '0').replace(/[^0-9]/g, '');
         return sum + (raw ? parseInt(raw, 10) : 0);
      }, 0
   );
}
/**
 * Restores cart quantities from cartListData into shipFlexProducts.
 * Called after getReviewData() completes to ensure buildLocationDatesPayload()
 * has valid location values when Place Order is clicked.
 * Covers the scenario where user navigates away from the review page and
 * comes back — shipFlexProducts locations have value='' after initShipFlexProducts()
 * but the cart already has saved quantities in cartListData.
 */
private restoreQuantitiesToShipFlexProducts(): void {
   // Only needed for inSeason (prebook doesn't use locationDates)
   if (this.seasonValue !== 'inSeason') return;

   // Need both shipFlexProducts and cartListData to be available
   if (!this.shipFlexProducts?.length || !this.cartListData?.data) return;

   this.cartListData.data.forEach((reviewProduct: any) => {
      const matchingProduct = this.shipFlexProducts.find(
         (p: any) => p.code === reviewProduct.productCode
      );
      if (!matchingProduct) return;

      // Restore per-location quantities from cartListData
      reviewProduct.locations?.forEach((reviewLoc: any) => {
         const locIdx = matchingProduct.location.findIndex(
            (l: any) => l.locID === reviewLoc.locID
         );
         if (locIdx > -1 && reviewLoc.locqtn) {
            matchingProduct.location[locIdx].value = Number(reviewLoc.locqtn);
         }
      });

      // Recalculate grand total so hasQtyForLocation() returns true
      const sum = matchingProduct.location.reduce(
         (acc: number, loc: any) => acc + Number(loc.value || 0), 0
      );
      matchingProduct.totalquantity = sum;
   });

   // Keep selectedProducts in sync
   this.selectedProducts = this.shipFlexProducts;
}
private saveConfirmedDatesToSession(): void {
  // Serialize: Date → ISO string
  const serialized: Record<string, string> = {};
  Object.entries(this.confirmedDates).forEach(([key, date]) => {
    if (date instanceof Date && !isNaN(date.getTime())) {
      serialized[key] = date.toISOString();
    }
  });
  sessionStorage.setItem(this.SESSION_KEY_DATES, JSON.stringify(serialized));
}

private restoreConfirmedDatesFromSession(): void {
  const raw = sessionStorage.getItem(this.SESSION_KEY_DATES);
  if (!raw) return;
  try {
    const parsed: Record<string, string> = JSON.parse(raw);
    Object.entries(parsed).forEach(([key, iso]) => {
      const d = new Date(iso);
      if (!isNaN(d.getTime())) {
        this.confirmedDates[key] = d;
      }
    });
  } catch {
    sessionStorage.removeItem(this.SESSION_KEY_DATES);
  }
}
 /*==== Method END ===*/


   ngAfterViewInit() {
      
      
 if (this.calendar) {
   this.calendar.stateChanges.subscribe(() => {
     if (this.isCalendarOpen) {
       this.updateMonthLabel();
       this.cdr.detectChanges();
     }
     
   });
 }


      this.startOrderService.getquantityData().subscribe((data: any) => {
         if(data==false){
            this.scrollToTop();
            this.handleOnPlaceOrderBtnClick();

         }
         else if(data==true){
            
            this.quantityincreased=true;
            this.duplicateproductform.forEach((dupliproduct: any) => {
               let totalquantity=0;
             this.orderLists?.preBookProducts.forEach((productdata:any)=>{
           
            
               
               if(productdata?.code==dupliproduct.productCode){
                  dupliproduct.shipLocationQty.forEach((shippinglocation:any)=>{
                     productdata?.location.forEach((location:any)=>{
                        if(location.locID==shippinglocation.locID){
                           location.value=shippinglocation.increaseqty;
                        }
                     })
                     totalquantity= totalquantity + shippinglocation.increaseqty
                  })
               
               productdata.totalquantity=totalquantity
               productdata.totalDoses=totalquantity*productdata?.doses;
               productdata.totalAmount=totalquantity*productdata.priceData.value;
               productdata.totalAmount=new Intl.NumberFormat("en",
                  { style: 'currency', currency: "USD", minimumFractionDigits: 2 }
               ).format(productdata.totalAmount);
               }
            });
           
         });
        this.cdr.detectChanges();
         }
      }); 
   }
   checkPrePaymentCustomer(): boolean {
      return sessionStorage
         .getItem(this.SESSION_KEY_PREPAYMENT)
         ?.trim()
         .toLowerCase() === 'yes';
   }
   handlePrePaymentPopupClose(): void {
      this.handleOnPrePaymentNo();
   }
}
